module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_06_1280_1280_ko-ec7bf1eb3c5c0307b392328660037ed9.jpg";